<template>

  <div class="detail">
    <i @click="$router.push('/')" class="detail__back mdi mdi-keyboard-backspace"></i>
    <div class="detail__image">
      <img v-if="client.photos" :src="$BACK_URL+'storage/'+client.photos[0].value" alt="">
      <div class="detail__bonus" v-if="client.bonus_setting.type === 'n_bonus'">{{ client.bonus_setting.count_value }}-я бесплатно</div>
      <div class="detail__bonus" v-else>{{ client.bonus_setting.bonus_value }}%</div>
    </div>
    <div class="detail__bottom">
      <p class="detail__title">{{ client.name }}</p>
    </div>




    <div class="detail__tabs">
        <p @click="detail__tab=1" :class="{ 'detail__tabs--active': detail__tab === 1 }">Детали</p>
        <p @click="detail__tab=2" :class="{ 'detail__tabs--active': detail__tab === 2 }">Бонусы</p>
        <p @click="detail__tab=3" :class="{ 'detail__tabs--active': detail__tab === 3 }">Гости</p>
        <p @click="detail__tab=4" :class="{ 'detail__tabs--active': detail__tab === 4 }">Отзывы</p>
    </div>


    <div v-if="detail__tab === 1" class="detail__description">
        <p>Описание</p>
        <p>{{ client.description }}</p>


        <p>Рабочее время</p>
        <p>Сегодня 09:00 - 19:00</p>



        <div class="client__phone" v-for="(phone, phone_index) in client.phones" :key="phone_index">
          <a :tel="phone.value">
            <i class="mdi mdi-cellphone"></i>
            <p>{{ phone.value }}</p>
          </a>
        </div>


        <div class="client__socials" v-for="(social, social_index) in client.socials" :key="social_index">
          <a>
            <i v-if="social.name === 'Instagram'"  class="mdi mdi-instagram mr-1"></i>
            <i v-else-if="social.name === 'Whatsapp'"  class="mdi mdi-whatsapp mr-1"></i>
            <i v-else class="mdi mdi-link mr-1"> </i>
          </a>
        </div>
    </div>

    <div v-if="detail__tab === 2"  class="detail__bonus">

    </div>

    <div v-if="detail__tab === 3"  class="detail__guests">

    </div>

    <div v-if="detail__tab === 4"  class="detail__feedbacks">

    </div>




  </div>

</template>

<script>
export default {
  name: "CompanyDetail",
  data() {
    return {
      company__detail: '',
      client: '',
      detail__tab: 1
    }
  },
  mounted() {
    this.getCompanyDetail(this.$route.params.id);
  },
  methods: {
    async getCompanyDetail(id) {
      try {
        const response = await this.$axios.get(`${this.$API_URL}guest/client?id=${id}`);
        this.client = response.data;
      } catch (error) {
        console.error("There was an error fetching the company detail:", error);
      }
    }
  }
};
</script>

<style>
.detail {
  img {
    width: 100%;

  }
}

.detail__bottom {
  padding: 20px;

  .detail__title {
    font-size: 24px;
    font-weight: bold;
  }
}
.detail__tabs {
  display: flex;
  flex-direction: row;
  align-self: center;
  padding: 20px;

  p {
    margin-right: 20px !important;
  }

  .detail__tabs--active {
    border-bottom: 2px solid #117a8b;
  }

}

.detail__description {
  padding: 20px;
}

.client__phone {
  a {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;

    p {
      margin-bottom: 0;
    }
  }
}

.client__socials {
  display: flex;
  flex-direction: row;
  i {
    font-size: 30px;
  }
}

.detail__back {
  padding: 20px;
  font-size: 40px;
  cursor: pointer;
}

.detail__image {
  position: relative;
}
.detail__bonus {
  position: absolute;
  right: 20px;
  bottom: -20px;
  background: #3baf26;
  padding: 10px;
  color: white;
  max-width: 150px;
  text-align: center;
}


</style>
